import { render, staticRenderFns } from "./ClientDetails_Invoice.vue?vue&type=template&id=97f8a6a2&"
import script from "./ClientDetails_Invoice.vue?vue&type=script&lang=js&"
export * from "./ClientDetails_Invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports